var map = {
	"./logo_pn_en.svg": 584,
	"./logo_pn_fr.svg": 585,
	"./logo_pn_invert_en.svg": 120,
	"./logo_pn_invert_fr.svg": 121,
	"./logo_pn_invert_nl.svg": 122,
	"./logo_pn_nl.svg": 586
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 583;